export function HttpService(urlDetails) {
  this.url = urlDetails[0];
  this.authCode = urlDetails[1];
  this.payload = {};

  this.getRequest = async function () {
    const requestUrl = this.url;

    try {
      const response = await fetch(requestUrl, {
        method: "GET",
        headers: {
          Authorization: this.authCode,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        // handle response errors
      }

      return await response.json();
    } catch (error) {
      window.isBadRequest = true;
      return null;
    }
  };

  this.postRequest = async function () {
    const data = this.payload;
    const requestUrl = this.url;

    try {
      const response = await fetch(requestUrl, {
        method: "POST",
        headers: {
          Authorization: this.authCode,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorText = await response.text();
        // handle response errors
      }

      return await response.json();
    } catch (error) {
      window.isBadRequest = true;
      return null;
    }
  };
}
